import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { getThousandSeparator, getDecimalSeparator } from '@e4/intl';
import PropTypes from 'prop-types';
import {
  InputContainer,
  InputContainerProps,
  InputField,
  InputFieldProps,
} from './components';

// See NumberFormat proptypes here: https://github.com/s-yadav/react-number-format#props
export const NumericInputProps = {
  // eslint-disable-next-line react/forbid-foreign-prop-types
  ...NumberFormat.propTypes,
  ...InputContainerProps,
  ...InputFieldProps,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

class NumericInput extends Component {
  static propTypes = {
    ...NumericInputProps,
  };

  render() {
    const { fieldSuffix, id, label, isValid, errorMessage, ...rest } =
      this.props;

    return (
      <InputContainer
        suffix={fieldSuffix}
        id={id}
        label={label}
        isValid={isValid}
        errorMessage={errorMessage}
      >
        <NumberFormat
          id={id}
          data-testid={id}
          isValid={isValid}
          customInput={InputField}
          decimalSeparator={getDecimalSeparator()}
          thousandSeparator={getThousandSeparator()}
          {...rest}
        />
      </InputContainer>
    );
  }
}

export default NumericInput;
